module.exports = __webpack_public_path__ + "img/nasa-01-blanc.e7ac6672.svg";